import React, {createContext} from 'react';

import firebase, {fdb} from './config';

const FirebaseContext = createContext();

const FirebaseContextProvider = ({children}) => {
    return (
        <FirebaseContext.Provider value={firebase}>
            {children}
        </FirebaseContext.Provider>
    );
}

const FirestoreContext = createContext();

const FirestoreContextProvider = ({children}) => {
    return (
        <FirestoreContext.Provider value={fdb}>
            {children}
        </FirestoreContext.Provider>
    );
}

export { 
    FirebaseContext, 
    FirebaseContextProvider,
    FirestoreContext,
    FirestoreContextProvider
 };